import { newActivationModal } from "./ActivationModal";
import { ActivateStudents } from "./StudentsActivator";


export function loadStudentActivationFunctionality(courseId:number, role='admin'){
     
    const activator = new ActivateStudents(courseId, role); // role if shown to admin

    addListener(activator);

    return activator;
}

function addListener(activator){
    $(document).on("click", ".load-activate-students", function(){
        newActivationModal();
        activator.init();
    })
}